import Responsibility from './Responsibility'
export default Responsibility
